"use strict";
/**
 * Created by Ning Jiang on 5/2/2016.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameMode = void 0;
class GameMode {
}
GameMode.NORMAL = "NORMAL";
GameMode.RESPIN = "RESPIN";
GameMode.FREESPIN = "FREESPIN";
GameMode.GAMBLE = "GAMBLE";
GameMode.FREESPIN_RESPIN = "FREESPIN_RESPIN";
GameMode.NORMAL_AVALANCHE = "NORMAL_AVALANCHE";
GameMode.FREESPIN_AVALANCHE = "FREESPIN_AVALANCHE";
exports.GameMode = GameMode;
//# sourceMappingURL=GameMode.js.map